var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83327 13.8782L1.95508 10L5.83327 6.12988L6.70343 7.02088L4.34924 9.37507H15.6298L13.2756 7.02088L14.1666 6.12988L18.0368 10L14.1666 13.8782L13.2756 13L15.6298 10.625H4.34924L6.70343 13L5.83327 13.8782Z",
    fill: "#4D6663"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRange);
export default __webpack_public_path__ + "static/media/Range.71bbee3c87d396434512f6bbcc5d6b81.svg";
export { ForwardRef as ReactComponent };